
import React, { useEffect, useState } from "react"
import "./HealthChart.css"

// @ts-ignore
const HealthChart: React.FC = ({HealthChartData, setSelectedTimelineEnv, selectedTimelineEnv}) => {

  const [services, setServices] = useState<any>(HealthChartData ? HealthChartData?.services : [])

  const [activeFilter, setActiveFilter] = useState<string>("All")

  const toggleService = (index: number) => {
    const newServices = [...services]
    newServices[index].isExpanded = !newServices[index].isExpanded
    setServices(newServices)
  }

  useEffect(() => {
    setServices(HealthChartData ? HealthChartData?.services : [])
  }, [HealthChartData])

  useEffect(() => {
    selectedTimelineEnv && setActiveFilter(selectedTimelineEnv)
  }, [selectedTimelineEnv])

  const generateTimeLabels = () => {
    const labels = []
    // const startHour = 14
    const startHour =  HealthChartData &&  +HealthChartData?.endHour?.split(":")[0]

    for (let i = 0; i < 48; i += 2) {
      const hour = (startHour + i) % 24
      const formattedHour = hour.toString().padStart(2, "0") + ":00"
      labels.push(formattedHour)
    }
    return labels
  }

  const timeLabels = generateTimeLabels()

  return (
    <div className="api-health-container">
      <div className="api-health-header">
        <div className="header-content">
          <h2>API Health Status (48 Hours from last refresh)</h2>
          <p className="header-description">Tracks uptime and downtime performance over time.</p>
        </div>
        <div className="filter-buttons">
          {["All", "Dev", "QA", "Prod"].map((filter) => (
            <button
              key={filter}
              className={`filter-btn ${activeFilter?.toLowerCase() === filter?.toLowerCase() ? "active" : ""}`}
              // className={`filter-btn ${selectedTimelineEnv === filter?.toLocaleLowerCase() ? "active" : ""}`}
              onClick={() => {
                setActiveFilter(filter?.toLowerCase())
                setSelectedTimelineEnv(filter?.toLowerCase())
              }}
            >
              {filter}
            </button>
          ))}
        </div>
      </div>

      <div className="services-grid">
        <div className="services-list">
          {services.map((service:any, index:any) => (
            <React.Fragment key={service.name}>
              <div className="service-row">
                <div className="service-name">
                  {service.isExpandable && (
                    <button className="expand-btn" onClick={() => toggleService(index)}>
                      {service.isExpanded ? "−" : "+"}
                    </button>
                  )}
                  <span>{service.name}</span>
                </div>
                <div className="blocks-container">
                  {service.blocks.map((block:any, blockIndex:any) => (
                    <div
                      key={blockIndex}
                      className={`status-block ${block.status}`}
                      // title={`${block.status} at hour ${blockIndex}`}
                    />
                  ))}
                </div>
              </div>

              {service.isExpanded &&
                service.children &&
                service.children.map((child:any) => (
                  <div key={child.name} className="service-row">
                    <div className="service-name child-name">
                      {/* <span>{child.name}</span> */}
                      <span title={child.name}>
                        {child.name.length > 10
                          ? `${child.name.slice(0, 10)}...`
                          : child.name}
                      </span>
                    </div>
                    <div className="blocks-container">
                      {child.blocks.map((block:any, blockIndex:any) => (
                        <div
                          key={blockIndex}
                          className={`status-block ${block.status}`}
                          // title={`${block.status} at hour ${blockIndex}`}
                        />
                      ))}
                    </div>
                  </div>
                ))}
            </React.Fragment>
          ))}
        </div>

        <div className="time-axis">
          {timeLabels.map((label, index) => (
            <div key={index} className="time-label">
              {label}
            </div>
          ))}
        </div>

        <div className="date-labels">
          <div className="date-label start-date">{HealthChartData?.startDate}</div>
          <div className="date-label end-date">{HealthChartData?.endDate}</div>
        </div>
      </div>

      <div className="legend">
        <div className="legend-item">
          <div className="legend-dot uptime"></div>
          <span>Uptime</span>
        </div>
        <div className="legend-item">
          <div className="legend-dot downtime"></div>
          <span>Downtime</span>
        </div>
      </div>
    </div>
  )
}

export default HealthChart
